import React from "react";
import Modal from "react-bootstrap/Modal";
import TablaFormatoReporte from "./TablaFormatoReporte";
//UI
import { DangerButton, SuccessButton } from "../../../../ui/buttons/Button";
import { Checkbox, Input, Radio, SearchInput, Select  } from "../../../../ui/inputs/Input";

export default function ReportesGenerales({ show, setShow, setTabla }) {
  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Reportes Generales</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: 500, overflowY: 'auto' }}> 
        <nav>
          <div className="nav nav-tabs mb-2" id="nav-tab" role="tablist">
            <button
              className="nav-link active"
              id="nav-formatoReporte-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-formatoReporte"
              type="button"
              role="tab"
              aria-controls="nav-formatoReporte"
              aria-selected="true"
            >
              Formato de Reporte
            </button>
            <button
              className="nav-link"
              id="nav-criteriosSeleccion-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-criteriosSeleccion"
              type="button"
              role="tab"
              aria-controls="nav-criteriosSeleccion"
              aria-selected="false"
            >
              Criterios de Selección
            </button>
            <button
              className="nav-link"
              id="nav-ordenarPor-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-ordenarPor"
              type="button"
              role="tab"
              aria-controls="nav-ordenarPor"
              aria-selected="false"
            >
              Ordenar Por
            </button>
          </div>
        </nav>
        <div className="tab-content" id="nav-tabContent">
          <div
            className="tab-pane fade show active"
            id="nav-formatoReporte"
            role="tabpanel"
            aria-labelledby="nav-formatoReporte-tab"
            tabindex="0"
          >
            <TablaFormatoReporte />
          </div>
          <div
            className="tab-pane fade"
            id="nav-criteriosSeleccion"
            role="tabpanel"
            aria-labelledby="nav-criteriosSeleccion-tab"
            tabindex="0"
          >
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Cod. Integrante:</span>
              <div className="col-3 m-0 p-0">
                <SearchInput label = 'Desde:' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <SearchInput label = 'Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <div className="col-6 m-0 p-0">
                <div className="col-8 m-0 p-0">
                  <Input label = 'Parentesco:' />
                </div>
              </div>
              <div className="col-6 m-0 p-0 d-flex gap-2">
                <span className="fw-bold">Sexo Familiar:</span>
                <div className="col-auto m-0 p-0">
                  <Radio label = 'Masculino' name = 'sexo' id = 'sexo1'/>
                </div>
                <div className="col-auto m-0 p-0">
                  <Radio label = 'Femenino' name = 'sexo' id = 'sexo2'/>
                </div>
                <div className="col-auto m-0 p-0">
                  <Radio label = 'Todos' name = 'sexo' id = 'sexo3'/>
                </div>
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <div className="col-6 m-0 p-0 d-flex gap-2">
                <span className="fw-bold">Estudiantes:</span>
                <div className="col-auto m-0 p-0">
                  <Radio label = 'Sí' name = 'estudiantes' id = 'estudiantes1'/>
                </div>
                <div className="col-auto m-0 p-0">
                  <Radio label = 'No' name = 'estudiantes' id = 'estudiantes2'/>
                </div>
                <div className="col-auto m-0 p-0">
                  <Radio label = 'Todos' name = 'estudiantes' id = 'estudiantes3'/>
                </div>
              </div>
              <div className="col-6 m-0 p-0 d-flex gap-2">
                <span className="fw-bold">Sexo Trabajador:</span>
                <div className="col-auto m-0 p-0">
                  <Radio label = 'Masculino' name = 'sexo' id = 'sexo1'/>
                </div>
                <div className="col-auto m-0 p-0">
                  <Radio label = 'Femenino' name = 'sexo' id = 'sexo2'/>
                </div>
                <div className="col-auto m-0 p-0">
                  <Radio label = 'Todos' name = 'sexo' id = 'sexo3'/>
                </div>
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Edad:</span>
              <div className="col-3 m-0 p-0">
                <Input label = 'Desde:' type = 'date' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input label = 'Hasta:' type = 'date' />
              </div>
            </div>
            <div className="col-4 m-0 mb-2 p-0 d-flex">
              <Select label = 'Estatus:'></Select>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Cod.Departamento:</span>
              <div className="col-3 m-0 p-0">
                <SearchInput label = 'Desde:' />
              </div> 
              <div className="col-3 m-0 p-0 pl-2">
                <SearchInput label = 'Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Cod. Unidad Funcional:</span>
              <div className="col-3 m-0 p-0">
                <SearchInput label = 'Desde:' />
              </div> 
              <div className="col-3 m-0 p-0 pl-2">
                <SearchInput label = 'Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Cod. Cargo:</span>
              <div className="col-3 m-0 p-0">
                <SearchInput label = 'Desde:' />
              </div> 
              <div className="col-3 m-0 p-0 pl-2">
                <SearchInput label = 'Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Cod. Banco:</span>
              <div className="col-3 m-0 p-0">
                <SearchInput label = 'Desde:' />
              </div> 
              <div className="col-3 m-0 p-0 pl-2">
                <SearchInput label = 'Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Fecha de Cumpleaños:</span>
              <div className="col-3 m-0 p-0">
                <Input label = 'Desde:' />
              </div> 
              <div className="col-3 m-0 p-0 pl-2">
                <Input label = 'Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex gap-2">
              <span className="col-6 m-0 p-0 fw-bold">Aumento de Sueldos:</span>
              <div className="col-auto m-0 p-0">
                <Radio label = 'Todos' name = 'aumento' id = 'aumento1'/>
              </div>
              <div className="col-auto m-0 p-0">
                <Radio label = 'Aplicados' name = 'aumento' id = 'aumento2'/>
              </div>
              <div clqassName="col-auto m-0 p-0">
                <Radio label = 'Por Aplicar' name = 'aumento' id = 'aumento3'/>
              </div>
            </div>
            <div className="col-4 m-0 mb-2 p-0">
              <Input label = 'Monto Cesta Ticket:' />
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <div className="col-6 m-0 p-0">
                <Select label = 'Grado de Instrucción:' ></Select>
              </div>
              <div className="col-6 m-0 p-0 pl-2">
                <Select label = 'Especialidad:' ></Select>
              </div>
            </div>
            <div className="col-6 m-0 mb-2 p-0">
              <Select label = 'Mención:' ></Select>
            </div>
            <div className="col-12 m-0 p-0">
              <Input label = 'Titulo del Reporte:' />
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-ordenarPor"
            role="tabpanel"
            aria-labelledby="nav-ordenarPor-tab"
            tabindex="0"
          >
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton>Aceptar</SuccessButton>
        <DangerButton>Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
}
